// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { Api } from "../../../api";
import { Product } from "#/common/interfaces/conversionworld/Product";
import { ScrollIndicator } from "../../../components/scroll_indicator/ScrollIndicator";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ScrollIndicator,
  },
})
export class StageSoftConfiguratorModule extends ModuleBase {
  products: Product[] = [];
  currentProduct = 0;
  branchenId;
  einsatzzweckId;

  getBackgroundColorFromInstance(instance: object): string {
    return "black";
  }

  async created() {
    let products = await Api.conversionWorldService.getProducts(
      {
        page_id: this.$store.page.page!.id,
        query: "",
        branchen: [],
        countries: [],
        solutions: [],
        model_series: [],
        bodybuilder: [],
        tag: "topseller",
      },
      "both",
      0,
      3
    );
    this.products = products.resultList;
  }

  mounted() {
    this.branchenId = this.$store.page.page!.route_parameter["branchenId"];
    this.einsatzzweckId =
      this.$store.page.page!.route_parameter["einsatzzweckId"];
  }

  beforeDestroy() {}

  get backgroundImage() {
    let branche = this.$store.conversionWorld.branchen.find(
      (b) => b.slug == this.branchenId
    );
    if (branche) {
      return branche.images.bg_image_without_vehicle;
    } else return "";
  }

  get firstButtonText() {
    let branche = this.$store.conversionWorld.branchen.find(
      (b) => b.slug == this.branchenId
    );
    if (branche) {
      return branche.title;
    } else return "";
  }

  get secondButtonText() {
    let branche = this.$store.conversionWorld.branchen.find(
      (b) => b.slug == this.branchenId
    );
    if (branche) {
      let solution = branche.loesungen.find(
        (s) => s.slug === this.einsatzzweckId || s.id == this.einsatzzweckId
      );
      if (solution) {
        return solution.alternative_title;
      } else return "";
    } else return "";
  }

  public handleBack($event) {
    $event.preventDefault();
    window.history.back();
  }

  public isChecked(product) {
    return (
      this.$store.conversionWorld.compareProducts.findIndex(
        (p) => p.id == product.id
      ) >= 0
    );
  }

  public addProduct(product, value) {
    this.$store.conversionWorld.setCompareProduct(product, value);
  }

  public handleShowProduct(index) {
    this.currentProduct = index;
  }

  public handleShowNextProduct() {
    if (
      this.currentProduct == this.products.length - 1 ||
      this.currentProduct == 2
    ) {
      let elem = this.$el as HTMLElement;
      let box = elem.getBoundingClientRect();
      let topPos = box.top + box.height + document.documentElement.scrollTop;
      window.scroll({ top: topPos, left: 0, behavior: "smooth" });
    } else if (this.currentProduct < this.products.length) {
      this.currentProduct += 1;
    }
  }
}
